module.exports = __webpack_public_path__ + "static/media/Finoptsys_preview.ccde571d.mp4";